export const enum E_TipoBusquedaLIO {
    Ninguna = 0,
    Generadas = 1,
    Asignadas = 2,
    Completadas = 3,
    Aasignadas = 4,
    Acompletadas = 5
  }